const getQueryString = () => {
  const params = new URLSearchParams(window.location.search);
  const rawQuery = params.get('query') || '';
  return rawQuery.replace('%2F/g', '/');
};

export const getPageData = (pageName: string) => {
  const queryStringData = getQueryString() ? getQueryString() : null;
  const pageData = {
    pageName,
    type: 'Transactional',
    siteType: 'Eclaims',
    brand: 'Manulife',
    loB: 'Insurance',
    segment: 'Asia',
    country: 'Japan',
    title: document.title,
    domain: window.location.hostname,
    ...(queryStringData && { queryString: queryStringData }),
    path: window.location.pathname,
    pageURL: window.location.href,
    userAgent: window.navigator.userAgent,
    botDetector: window.navigator.webdriver,
    hash: window.location.hash || null,
    language: 'jp',
    previousPageData: document.referrer || null,
    pageNavPosition: document.documentElement.scrollTop || document.body.scrollTop,
  };

  return pageData;
};

/**
 * This function returns a string hashed in SHA-256.
 *
 * @returns {string} A string hashed
 */
const sha256Hash = async (fieldToHash: string) => {
  const encoderBuffer = new TextEncoder().encode(fieldToHash);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoderBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

/**
 * Returns user components following the standards for page load analytics.
 *
 * @return {Object} The user event info for analytics.
 */
export const userDataAnalytics = async (userData: any) => {
  const medallia = sessionStorage.getItem('Feedback_UUID') ? sessionStorage.getItem('Feedback_UUID') : null;
  const userEmail = userData?.contactInformation?.email ? await sha256Hash(userData.contactInformation.email) : null;
  const ecid = (window as any)._satellite && (window as any)._satellite.getVisitorId() ? (window as any)._satellite.getVisitorId().getMarketingCloudVisitorID() : null;
  const EVENT_INFO = {
      ...(userData?.mcfId && { primaryCustomerID: userData.mcfId }),
      ...(medallia && { medalliaUUID: medallia }),
      ...(ecid && { anonymousID: ecid}),
      ...(userEmail && { emailAddressHashed: userEmail }),
      type: 'Customer'
  };
  return EVENT_INFO;
};